import React from "react";
import ImgSrcBackgroundImageDesktop from "../assets/img/health-support/Ask-A-Medical-Expert_580x400_Mother_daughter.jpg";
import ImgSrcBackgroundImageTablet from "../assets/img/health-support/Ask-A-Medical-Expert_580x400_Mother_daughter.jpg";
import ImgSrcBackgroundImageMobile from "../assets/img/health-support/Ask-A-Medical-Expert_580x400_Mother_daughter.jpg";
import {
  getOpeningHours,
  getPhoneClaims,
  getOpeningHoursClaims
} from "./../helpers/ContentStateHelper";
import styles from "../assets/css/modules/health-support/ask-a-medical-expert.css";
import { Paths, Urls } from "../constants/UrlConstants";
import BannerSpeakToExperiencedSrc from "../assets/img/health-support/SpeakToExperienced_584x386.png";
import BannerMolSpeakToExperiencedSrc from "../assets/img/health-support/SpeakToExperienced_584x386.png";
import BannerSpeakToExperiencedHeartNurseSrc from "../assets/img/health-support/SpeakToExperiencedHeartNurse_584x386.png";
import BannerMolSpeakToExperiencedHeartNurseSrc from "../assets/img/health-support/SpeakToExperiencedHeartNurse_584x386.png";
import PromoSpeakToExperiencedSrcMobile from "../assets/img/health-support/SpeakToExperienced_584x386.png";
import PromoSpeakToExperiencedHeartNurseSrcMobile from "../assets/img/health-support/SpeakToExperiencedHeartNurse_584x386.png";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { ButtonConfig } from "../constants/Constants";

const isHealthAtHandIncluded =
  "Is the 24/7 support line included as part of my plan?";

const isHealthAtHandIncludedForMOL =
  "Is the 24/7 support line included as part of my plan?";

export default {
  Heading: { Any: "24/7 health support line", HOL: "24/7 health support line" },
  BackgroundDesktopImage: ImgSrcBackgroundImageDesktop,
  BackgroundTabletImage: ImgSrcBackgroundImageTablet,
  BackgroundMobileImage: ImgSrcBackgroundImageMobile,
  HeroContent: {
    Any: (
      <React.Fragment>
        <h1>24/7 health support line</h1>
        <p>
          Get clear, up-to-date information and support, day and night
        </p>
        <p>
        <ul className={styles.section1}>
        <li>Available to you whenever you need it</li>
        <li>Direct phone access to experienced nurses and counsellors</li>
        <li>Included in your membership as standard</li>
      </ul>
        </p>

      </React.Fragment>
    ),
    International: (
      <React.Fragment>
        <h1>24/7 health support line</h1>
        <p>
          You can speak to one of our expert nurses, counsellors, midwives and
          pharmacists about your health, anytime.
        </p>
        <p>
          <strong>Health at Hand</strong> are here to give you the information
          that you need and to help put your mind at ease.
        </p>
      </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        <h1>24/7 health support line</h1>
        <p>
          Get clear, up-to-date information and support, day and night
        </p>
        <p>
        <ul className={styles.section2}>
        <li>Available to you whenever you need it</li>
        <li>Direct phone access to experienced nurses and counsellors</li>
        <li>Included in your membership as standard</li>
      </ul>
        </p>
      </React.Fragment>
    )
  },
  SpeakAnyQuestion: {
    Any: (props) => (
      <React.Fragment>
      <p>
       <strong> In an emergency, call 999 straight away </strong>
      </p>
      </React.Fragment>
    )
  },
  AskAnExpertOnline: "Ask an expert online",
  AskAMedicalExpet: {
    Any: <a style={{ color: "white" }} id={ButtonConfig.TwentyfourCallh} href="tel:0800 003 004"> Call 0800 003 004 </a>,
    HOL: <a style={{ color: "white" }} id={ButtonConfig.TwentyfourCallh} href="tel:0800 003 004"> Call 0800 003 004 </a>,
  },
  AskAMedicalExpetCall:{
    Any: <a style={{ color: "white" }} id={ButtonConfig.TwentyfourCallb} href="tel:0800 003 004"> Call 0800 003 004 </a>,
    HOL: <a style={{ color: "white" }} id={ButtonConfig.TwentyfourCallb} href="tel:0800 003 004"> Call 0800 003 004 </a>,
  },
  SpeaktoExpCancerNurse: {
    Any: "Call 0800 111 4811 ",
    HOL: "Call 0800 111 4811 "
  },
  SpeaktoExpHeartNurse: {
    Any: "Call 0800 218 2303 ",
    HOL: "Call 0800 218 2303 "
  },
  SendAMessage: {
    Any: "Send a message               ",
    HOL: "Send a message               ",
  },
  SupportButtonType : {
    HOL: "secondaryOrangeButton",
    Any: "secondaryBlueButton"
  },
  IconType: {
    HOL: "icon-email-HOL",
    Any: "icon-email",
  },
  SpeakToAnExpert: {
    Any: (
      <React.Fragment>
        <p className={styles.askAMedicalExpertPhoneNumber}>
          <strong>Or speak to an expert on a call</strong>
        </p>
        <p className={styles.phoneNumber}>
          <strong>0800 003 004</strong>
        </p>
        <p className={styles.openingHours}>24 hours a day, 365 days a year</p>
      </React.Fragment>
    ),
    International: (props) => (
      <React.Fragment>
        <p className={styles.askAMedicalExpertPhoneNumber}>
          <strong>Speak to an expert on a call</strong>
        </p>
        <p className={styles.phoneNumber}>
          <strong>0800 003 004 </strong>
          <span className={styles.phoneNumberLocation}>
            (within the UK and Channel Islands)
          </span>
        </p>
        <p className={styles.phoneNumber}>
          <strong>+44 (0) 1892 772578 </strong>{" "}
          <span className={styles.phoneNumberLocation}>
            (rest of the world)
          </span>
        </p>
        <p className={styles.openingHours}>{getOpeningHours(props)}</p>
      </React.Fragment>
    )
  },
  EmergenciesHeading: (
    <React.Fragment>
  <strong>Emergencies</strong>
  </React.Fragment>
  ),
  EmergenciesDescription:(
    <React.Fragment>
  The 24/7 Health Support line cannot respond to emergencies. If you require an urgent response or have a medical emergency please call 111/999 or attend A&E.
  </React.Fragment>
  ),
  Section1Heading: "Speak to a nurse or counsellor day and night",
  Section1Description: (
    <React.Fragment>
      <p></p>
      <strong className={styles.sectionDescription}>Our experienced nurses and counsellors are here 24/7 to support you when you need it most</strong>
      <ul className={styles.section2}>
        <li>You might be worried about a new diagnosis or some upcoming surgery. Ask one of our experienced nurses.</li>
        <li>If stress is stopping you from getting a night’s sleep, we’re here. Our counsellors can help, even at 4am.</li>
        <li>If you’re seeking insight into menopause or have related questions, our experienced nurses can assist you with managing symptoms like hot flushes, mood swings and brain fog. They can also guide you to specialised support if necessary.</li>
      </ul>
    </React.Fragment>
  ),
  Section2Heading: "Other experienced health professionals you can speak to on this service during the day",
  Section2Description: (
    <React.Fragment>
       <p></p>
    <strong className={styles.sectionDescription}>
      During the day, you can also speak to a midwife or pharmacist
    </strong>
    <ul className={styles.section2}>
      <li>If you need some reassurance during those early newborn days, speak to one of our friendly midwives.</li>
      <li>You may have some questions about your prescribed medication, one of our pharmacists will be happy to help.</li>
    </ul>
    <p><strong>8am - 8pm Monday to Friday</strong> <br></br>
    <strong>8am - 4pm Saturday</strong> <br></br>
    <strong>8am - 12pm Sunday </strong></p>
    </React.Fragment>
  ),
  Section2PhoneNumberExperienceNurse: (
    <React.Fragment>
      <p className={"mb-0 " + styles.nurseHeader}>
        Speak to an experienced heart nurse
      </p>
      <p
        className={
          "mb-0 " + styles.sectionDescription + " " + styles.phoneNumber
        }
      >
        <strong>0800 218 2303</strong>
      </p>
      <p className={styles.openingHours}>24 hours a day, 365 days a year</p>
    </React.Fragment>
  ),
  Section2PhoneNumberExperienceNurseForCancer: (
    <React.Fragment>
      <p className={"mb-0 " + styles.nurseHeader}>
        Speak to an experienced cancer nurse
      </p>
      <p
        className={
          "mb-0 " + styles.sectionDescription + " " + styles.phoneNumber
        }
      >
        <strong>0800 111 4811</strong>
      </p>
      <p className={styles.openingHours}>24 hours a day, 365 days a year</p>
    </React.Fragment>
  ),
  Section3Heading: "Getting a second opinion",
  Section3Description: (
    <span className={styles.sectionDescription}>
      If your specialist recommended an operation or particular treatment for
      you, and you’re not feeling sure about it, get in contact. We can arrange
      for you to meet another specialist who’ll consider whether a different
      course of action could be right for you.
    </span>
  ),
  Section3OutPatientDescription: (
    <span className={styles.sectionDescription}>
      You'll need to have cover for out-patient consultations and diagnostic
      tests.
    </span>
  ),
  Section3PhoneNumberExperienceNurse: {
    Any: (props) => (
      <React.Fragment>
        <p className={"mb-0 " + styles.nurseHeader}>Get a second opinion</p>
        <p
          className={
            "mb-0 " + styles.sectionDescription + " " + styles.phoneNumber
          }
        >
          <strong>{getPhoneClaims(props)}</strong>
        </p>
        <p className={styles.openingHours}>{getOpeningHoursClaims(props)}</p>
      </React.Fragment>
    )
  },

  HelpSet: [
    {
      Question: {
        Any: isHealthAtHandIncludedForMOL,
        International: isHealthAtHandIncluded,
        HOL: isHealthAtHandIncluded,
        Saga: isHealthAtHandIncluded
      },
      Answer: (
        <p>
          Yes, this support line is available to you and your family, with nurses and counsellors 
          available 24/7 and pharmacists and midwives available: Monday to Friday 8am – 8pm, Saturday 
          8am - 4pm and Sunday 8am - 12pm. All calls are confidential. We may record and/or 
          monitor calls for quality assurance, training and as a record of our conversation.
        </p>
      )
    },
    {
      Question: "When can I expect to hear back from a health professional?",
      Answer: {
        Any: (
          <p>
            Call us on 0800 003 004 and we can arrange a call back at a convenient time for you.
            Or send a message and we’ll respond within 24hrs.<br></br>
            Please don't send photos as this is not a diagnostic service.
          </p>
        ),
        International: (
          <p>
            Give us a call and we can arrange a call back at a time convenient
            for you.
          </p>
        )
      }
    },
    {
      Question: "What alternatives are there to get help with my condition?",
      Answer: {
        Any: (
          <p>
            Give us a call and our health professionals can talk to you about your condition and 
            alternatives that could be available.
          </p>
        ),
        International: (
          <p>
            Give us a call and our team of experts can talk to you about your
            condition and alternatives that are available.
          </p>
        )
      }
    }
  ],
  Cards: {
  SpeaktoExperiencedCancerNurse: {
    IconSrc: {
      HOL: BannerSpeakToExperiencedSrc,
      Any: BannerMolSpeakToExperiencedSrc,
    },
    IconSrcMobile: {
     HOL: PromoSpeakToExperiencedSrcMobile,
     Any: PromoSpeakToExperiencedSrcMobile,
    },
    Heading:{
      HOL: "Speak to an experienced cancer nurse",
      Any: "Speak to an experienced cancer nurse",
    },
    Description1:{
    Any: (
      <React.Fragment>
        We know that a cancer diagnosis for yourself or a loved one has a huge impact. So our team of cancer nurses are here to listen, support, and help with any questions you may have. They’ll be a consistent point of contact throughout treatment and beyond.
        <p></p>
        Available 9am-5pm Monday to Friday.<br></br>
        Outside these hours our {" "}
        </React.Fragment>
    ),
    HOL: (
      <React.Fragment>
        We know that a cancer diagnosis for yourself or a loved one has a huge impact. So our team of cancer nurses are here to listen, support, and help with any questions you may have. They’ll be a consistent point of contact throughout treatment and beyond.
        <p></p>
        Available 9am-5pm Monday to Friday.<br></br>
        Outside these hours our {" "}
        </React.Fragment>
    ),
},
Description2:{
  Any: (
    <React.Fragment>
      <a
        className={layoutStyle.anchorDecorationUnderline}
        href={Urls.ExpNurseCounsellors}
        rel="noopener noreferrer"
        target="_blank"
      >
        experienced nurses and counsellors
      </a>{" "}
      </React.Fragment>
  ),
  HOL: (
    <React.Fragment>
      <a
        className={layoutStyle.anchorDecorationUnderline}
        href={Urls.ExpNurseCounsellors}
        rel="noopener noreferrer"
        target="_blank"
      >
        experienced nurses and counsellors
      </a>{" "}
      </React.Fragment>
  )
},
Description3:{
  Any: (
    <React.Fragment>
     {" "} provide round the clock support by phone.
      </React.Fragment>
  ),
  HOL: (
    <React.Fragment>
     {" "} provide round the clock support by phone.
      </React.Fragment>
  )
},
    LinkText:{
      HOL: "Find out more",
      Any: "Cancer diagnostic services",
    },
    LinkTo: {
      HOL: Paths.AskAMedicalExpert,
      Any: Paths.AskAMedicalExpert,
    },
    ExternalLinkTo: null,
    AriaLabel: {
      HOL: "Speak to an experienced cancer nurse",
      Any: "Find out more about the cancer diagnostic service",
    },
  },
  SpeaktoExperiencedHeartNurse: {
    IconSrc: {
      HOL: BannerSpeakToExperiencedHeartNurseSrc,
      Any: BannerMolSpeakToExperiencedHeartNurseSrc,
    },
    IconSrcMobile: {
     HOL: PromoSpeakToExperiencedHeartNurseSrcMobile,
     Any: PromoSpeakToExperiencedHeartNurseSrcMobile,
    },
    Heading:{
      HOL: "Speak to an experienced heart nurse",
      Any: "Speak to an experienced heart nurse",
    },
    Description1:{
      Any:(
        <React.Fragment>
          We have a team of nurses who are experienced in supporting members with heart disease. They are here to listen, support and help with any questions you may have.
          <p></p>
          Available 9am-5pm Monday to Friday.<br></br>{" "}
          Outside these hours our {" "}
          </React.Fragment>
      ),
      HOL:(
        <React.Fragment>
          We have a team of nurses who are experienced in supporting members with heart disease. They are here to listen, support and help with any questions you may have.
          <p></p>
          Available 9am-5pm Monday to Friday.<br></br>{" "}
          Outside these hours our {" "}
          </React.Fragment>
      ),
  },
  Description2:{
    MOL:(
      <React.Fragment>
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.ExpNurseCounsellors}
          rel="noopener noreferrer"
          target="_blank"
        >
          experienced nurses and counsellors
        </a>
        </React.Fragment>
    ),
    HOL:(
      <React.Fragment>
        <a
          className={layoutStyle.anchorDecorationUnderline}
          href={Urls.ExpNurseCounsellors}
          rel="noopener noreferrer"
          target="_blank"
        >
          experienced nurses and counsellors
        </a>
        </React.Fragment>
    ),
  },
  Description3:{
    MOL:(
      <React.Fragment>
        {" "} provide round the clock support by phone.
        </React.Fragment>
    ),
    HOL:(
      <React.Fragment>
        {" "} provide round the clock support by phone.
        </React.Fragment>
    ),
  },
    LinkText:{
      HOL: "Find out more",
      Any: "Cancer diagnostic services",
    },
    LinkTo: {
      HOL: Paths.AskAMedicalExpert,
      Any: Paths.AskAMedicalExpert,
    },
    ExternalLinkTo: null,
    AriaLabel: {
      HOL: "Find out more about the prostate cancer diagnostic service",
      Any: "Find out more about the cancer diagnostic service",
    },
  },
},
};
